<template>
    <div class="rectificat">
        <!-- 公共头部 -->
        <CommonHeader :info="headerInfo" :submitUserName="approvalRecordsInfo.taskEventData.firstUserName"></CommonHeader>
        <!-- 基本信息 -->
        <DRBaseInfoComponent :info="baseInfo"></DRBaseInfoComponent>
        <!-- 报告附件 -->
        <CommonFiles 
            :info="fileInfo" 
            v-show="fileInfo.files.length > 0"
            @getFilesData="getFilesData"></CommonFiles>
        <!-- 问题详情 -->
        <div class="details" v-show="problemList.length > 1">
            <header class="title">
                <span class="pole"></span>
                <span class="str">问题详情</span>
                <!-- <span class="show">查看全部 ></span> -->
            </header>
            <ul class="content">
                <van-row type="flex" style="line-height: 20px;" v-for="(item,index) in problemList" :key="index" @click="openDialog(item)">
                    <van-col span="7" :style="{color: index == 0 ? '' : '#0ea6e0'}">{{ item.problemId }}</van-col>
                    <van-col span="13">{{ item.problemName }}</van-col>
                    <van-col span="4" style="text-align: center;">{{ item.degreeName }}</van-col>
                </van-row>
            </ul>
        </div>
        <!-- 审批记录 -->
        <CommonApprovalRecords 
            :workFlowGuid="approvalRecordsInfo.businessKey"
            :workFlowFormVar="approvalRecordsInfo.formVar"
            :workFlowFormKey="approvalRecordsInfo.formKey">
        </CommonApprovalRecords>
        <!-- 审批form表单组件 -->
        <CommonForm
            :workFlowGuid="approvalRecordsInfo.businessKey"
            :workFlowFormKey="approvalRecordsInfo.formKey"
            :workFlowFormVar="approvalRecordsInfo.formVar"
            @sendWorkFlow="submitData"
            @taskEvent="taskEvent">
        </CommonForm>

        <!-- 问题详情弹窗-显示问题预览信息 -->
        <van-dialog 
            v-model="previewInfo.showDialog" 
            :show-confirm-button="false" 
            :close-on-click-overlay="true">
            <!-- 自定义关闭图标 -->
            <van-icon name="cross" class="icon" size="16px" @click="previewInfo.showDialog = false"></van-icon>
            <CommonPreview :info="previewInfo"></CommonPreview>
        </van-dialog>
    </div>
</template>
<script>
import {Toast} from 'vant-green'
import CommonHeader from '@/views/audit/components/CommonHeader'
import DRBaseInfoComponent from "@/views/audit/components/DRBaseInfoComponent"
import CommonFiles from '@/views/audit/components/CommonFiles'
import CommonApprovalRecords from "@/views/audit/components/CommonApprovalRecords"
import CommonForm from '@/views/audit/components/CommonForm'
import CommonPreview from '@/views/audit/components/CommonPreview'
import {timeStampTransformDate,timeTransformDate} from '@/utils/approve.js'
import {
    getWfStatusByProjectGuidData,
    getProjectView,
    getViewByGuidData,
    getDetailsReportData,
    getProblemListData,
    getReportWorkFlowId
} from "@/api/approve.js"
export default {
    components: {
        CommonHeader,
        DRBaseInfoComponent,
        CommonFiles,
        CommonApprovalRecords,
        CommonForm,
        CommonPreview
    },
    data(){
        return {
            //项目信息
            projectInfo: {},

            //公共头部数据
            headerInfo: {
                dataType: "详版报告审批",      //标题
            },
            //基本信息
            baseInfo: {
                //接口请求的数据
                detailsInfo: {},
                auditOrgName: "",                  //监审部门
                projectChiefJudgeName: "",         //项目经理
                businessFiledName: "",             //业务领域
                auditeeOrgName: "",                //被审单位

                businessTimeRange: "",             //业务时间范围   timeStart 和timeEnd的拼接
                auditBackground: "",               //项目背景
                auditObjective: "",                //项目目标

            },
            //公共整改措施附件
            fileInfo: {
                title: "报告附件",
                guids: "",
                files: [],
            },
            //问题列表
            problemList: [
                {
                    problemId: "编号",
                    problemName: "标题",
                    degreeName: "等级"
                }
            ],
            //审批记录相关数据
            approvalRecordsInfo: {
                businessKey: "",   //当前页面guid
                formVar: {
                    supervise: false
                },
                formKey: "TBL_PROJECT_REPORT",  //此事项的唯一标识，最好表名，
                taskEventData:{}
            },

            //问题详情单条数据信息
            previewInfo: {
                showDialog: false,          //显示弹窗

                problemName: '',
                degree: null,
                problemAccording: '',
                problemDesc: '',
                problemAffect: '',
                problemCauseList: [
                    // {
                    //     guid: '',
                    //     causeContent: '',
                    //     causeGuid: '',
                    //     combinationName: '',
                    //     causeType: '',
                    //     causeName: '',
                    // }
                ],
                problemAdviseList: [
                    // {
                    //     guid: '',
                    //     adviseContent: '',
                    //     adviseType: '',
                    //     adviseCategory: '',
                    //     adviseLevel: ''
                    // }
                ],
                problemZgList: [
                    // {
                    //     guid: '',
                    //     zgContent: '',
                    //     zgOrgGuidName: "",
                    //     zgPersonName: "",
                    //     zgCategory: '',
                    //     zgPerson: '',
                    //     zgLeader: '',
                    //     zgOrgGuid: '',
                    //     zgPlanEndTime: "",
                    //     zgStatus: '',
                    //     zgSituation: '',
                    //     zgOrgTreeGuid: ''
                    // }
                ],
            }
        }
    },
    async created(){
        document.title = "详版报告审批";
        let {guid} = this.$route.query;
        //获取项目阶段状态，看下是否有此阶段或者是否到达此阶段
        await this.getWfStatusByProjectGuidDataEvent(guid);
        // await this.getWfStatusByProjectGuidDataEvent('74ce6fc297144244bec5cc0e4875c5a6');
    },
    methods:{
        

        taskEvent(val){
            this.$set(this.approvalRecordsInfo,'taskEventData',val)
        },
        //获取项目阶段状态，看下是否有此阶段或者是否到达此阶段
        async getWfStatusByProjectGuidDataEvent(projectId){
            try{
                let res = await getWfStatusByProjectGuidData(projectId);
                console.log("让我看看怎么个事!");
                console.log(res)
                if (res.data.isComplete && res.data.isComplete == "false") {
                    this.$confirm("此项目尚未到达详版报告阶段?", "提示", {})
                    .then(() => {
                        this.$router.back(-1)
                    })
                    .catch(() => {
                        this.$router.back(-1)
                    })
                }
                //获取整改数据信息
                await this.getProjectViewEvent(projectId);
            }catch(error){
                // Toast({message: error,size: "small"});
            }
        },
        //获取整改数据信息
        async getProjectViewEvent(guid){
            try{
                let res = await getProjectView(guid);
                console.log("有没有搞错？");
                console.log(res);
                let data = res.data;
                this.projectInfo = data;
                this.$set(this.approvalRecordsInfo.formVar,'supervise',(data.property == 2 && data.auditOrgName != '监察部'));
                //填充公共头部信息
                this.fillHeaderData(data);
                //填充基本信息数据
                await this.fillBaseInfoData(data);
                //填充问题列表
                this.fillProblemListDataEvent(guid);
                //查询审批记录
                this.getApprovalRecordDataEvent(data);
            }catch(error){
                // Toast({message: error,size: "small"});
            }
        },
        //填充公共头部信息
        fillHeaderData(data){
            //项目名称
            this.headerInfo.dataName = data.projectName;
            //项目编号
            this.headerInfo.dataId = data.projectId;
        },
        //填充基本信息数据
        async fillBaseInfoData(data){
            this.baseInfo = {
                ...this.baseInfo,
                ...data
            }
            //填充业务时间范围
            try {
                let res = await getDetailsReportData(data.guid);
                console.log("我看那");
                console.log(res);
                //保存数据，审批记录用得着
                this.baseInfo.detailsInfo = res.data;
                this.baseInfo.businessTimeRange = timeTransformDate(res.data.projectStartTime) + "至" + timeTransformDate(res.data.projectEndTime);
                //填充报告附件
                if(res.data.detailReportFiles){
                    this.fileInfo.guids = res.data.detailReportFiles;
                }
            } catch(error) {
                console.log("离谱！");
                Toast({message: error,size: "small"});
            }
            
        },
        //打开问题详情弹窗
        async openDialog(data){
            console.log(data);
            try{
                if(data.guid){
                    let res = await getViewByGuidData(data.guid);
                    this.previewInfo = {
                        showDialog: true,
                        ...res.data
                    } 
                }
            }catch(error){
                Toast({message: error,size: "small"});
            }
        },
        //填充问题列表数据
        async fillProblemListDataEvent(guid){
            try{
                let res = await getProblemListData(guid);
                console.log("都有啥数据");
                console.log(res);
                let list = res.data;
                if(list.length > 0){
                    this.problemList = [...this.problemList,...list];
                }
            }catch(error){
                Toast({message: error,size: "small"});
            }
        },
        //获取附件信息
        getFilesData(data){
            this.fileInfo.files = data;
        },
        //填充审批记录数据
        async getApprovalRecordDataEvent(data){
            //设置审批记录的请求参数formVar
            this.approvalRecordsInfo.formVar.supervise = (data.property == 2 && data.auditOrgName != '监察部');
            console.log("到这来了吗？");
            try{
                //通过该接口获取请求审批记录的参数businessKey值
                let res = await getReportWorkFlowId(this.baseInfo.detailsInfo.guid);
                //填充审批记录请求guid，请求审批记录
                this.approvalRecordsInfo.businessKey = res.data.workflowguid;
            }catch(error){
                Toast({message: error,size: "small"});
            }
        },
        //表单提交审批数据
        submitData(val){
            this.Toast.success('审批成功')
            if(val==1){
                this.$http.get('/api/job/v0.1/project/detailReportApproveComplete?projectGuid=' + this.projectInfo.guid + '&wfStatus=' + val)
                .then(res => {
                    setTimeout(()=>{
                        location.reload()
                    },500)
                })
                .catch(err=>{
                    setTimeout(()=>{
                        location.reload()
                    },500)
                })
            }else{
                setTimeout(()=>{
                    location.reload()
                },500)
            }
        }
    }
}
</script>
<style lang="less" scoped>
    //主标题字号
    @titleSize: 16px;
    //主标题颜色
    @titleColor: #0ea6e0;
    //中等字号
    @middleSize: 14px;
    //主体小字字号
    @contentSize: 12px;
    //内容小字颜色
    @contentColor: #7f7f7f;

    //板块radius
    @borderRadius: 4px;

    //边框阴影
    @boxShadow: 2px 2px 5px 0 rgba(0, 0, 0, 0.2);

    //预览标题颜色
    @previewColor: #000;
    .rectificat{
        padding: 15px;
        background-color: #0ea6e0;
        position: relative;
        padding-bottom: 240px;
    }
    .details{
        background-color: #fff;
        border-radius: @borderRadius;
        box-shadow: @boxShadow;
        overflow: hidden;
        margin-top: 15px;
        padding-bottom: 10px;
        text-align: left;
        font-size: @contentSize;
        .title{
            margin: 20px 15px 0 15px;
            text-align: left;
            overflow: hidden;
            position: relative;
            .pole{
                color: @titleColor;
                font-size: @titleSize;
                border-left: 3px solid #0ea6e0;
            }
            .str{
                width: 100%;
                font-size: @middleSize;
                display: inline-block;
                margin-left: 5px;
                font-weight: bold;
                padding-bottom: 5px;
                border-bottom: 1px solid #d7d7d7;
            }
        }
        .content{
            margin: 10px 15px 5px 23px;
            padding-bottom: 3px;
            border-bottom: 1px solid #f3f3f3;
            .caption{
                color: @contentColor;
                img{
                    border: 1px solid #000 !important;
                    border-radius: @borderRadius !important;
                }
            }
        }
        .content:last-child{
            border: unset;
        }
    }
    .icon{
        position: absolute;
        right: 8px;
        top: 8px;
    }
    /deep/ .van-dialog__content{
        margin: 30px 10px;
        overflow: scroll;
        max-height: 400px;
        .content_left_title{
            margin: 0 0 30px !important;
        }
    }
    
</style>